<template lang="pug">
  div
    input(ref="uploadRef" @change="uploadFile" type="file" style="display: none;")
    quill-editor.mta-editor(
      ref="editor"
      v-model="text"
      :options="quillOptions"
    )

</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import utilMixin from '@/components/mixins/utilMixin'

  export default {
    mixins: [utilMixin],

    props: {
      value: {
        type: String,
        default: '',
      },
      options: {
        type: Object,
        default: () => {},
      },
      placeholder: {
        type: String,
        default: 'Insert text...',
      },
    },

    data() {
      return {
        text: this.value,
        quillOptions: {
          modules: {
            formula: true,
            toolbar: [
              [{ size: ['small', false, 'large', 'huge'] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              ['blockquote', 'code-block'],
              ['formula'],
              ['image','video'],
            ],
          },
          theme: 'snow',
          placeholder: this.placeholder,
        },
        imagePosition: 0,
      }
    },

    watch: {
      text() {
        this.$emit('input', this.text)
      },

      value() {
        if (this.value !== this.text) {
          this.$set(this, 'text', this.value)
        }
      },
    },

    created() {
      if (this.options && Object.keys(this.options).length > 0) {
        this.quillOptions = cloneDeep(this.options)
      }
      this.quillOptions.placeholder = this.placeholder
    },

    mounted() {
      const imgHandler = async (image) => {
        this.imagePosition = this.$refs.editor.quill.getSelection().index
        if (image) {
          this.openFileSelect()
        }
      }

      this.$refs.editor.quill.getModule('toolbar').addHandler('image', imgHandler)

      this.$refs.editor.$nextTick(() => {
          const selectors = ['button', '.ql-picker-label', '.ql-picker-item']
          const toolbar = this.$el.querySelector('.ql-toolbar')
          selectors.forEach((selector) => {
              toolbar.querySelectorAll(selector).forEach((element) => {
                  element.tabIndex = -1
              })
          })
      })
    },

    methods: {
      openFileSelect() {
        this.$refs.uploadRef.click()
      },

      uploadFile(e) {
        if (!e.target.files || e.target.files.length === 0) {
          return
        }

        const file = e.target.files[0]

        const formData = new FormData()
        formData.append('file', file)

        this.axios.post('/api/upload', formData, {
          headers: {
            'Content-Type': file.type,
          },
        })
          .then(({ data: { url } }) => {
            // Insert image url to editor
            e.target.value = ''
            this.$refs.editor.quill.insertEmbed(this.imagePosition, 'image', url)
          })
          .catch((error) => {
            e.target.value = ''
            this.mNotification({error: error, message:  'File not uploaded.'})
          })
      },
    },
  }
</script>

<style>
  .mta-editor .ql-tooltip.ql-editing {
    left: 10px !important;
    z-index: 999;
  }

  .mta-editor .ql-tooltip.ql-editing input {
    width: 400px;
  }

  .el-form-item.is-error .quill-editor {
    border: 1px solid #fa5555 !important;
  }

  .mta-editor .ql-editor {
    background-color: #fff;
  }
</style>
